"use client";

import { Program, SLPProgramType } from "@/services/types";
import Image from "next/image";
import Link from "next/link";
import { usePathname } from "next/navigation";
import { useEffect } from "react";
interface Props {
  learnerData: Program | undefined;
  programType?: SLPProgramType;
}
export default function SectionFixedCard(props: Props) {
  const learnerData = props.learnerData;
  const pathName = usePathname();
  useEffect(() => {
    document.querySelector(".section__footer")?.classList.add("section__footer--slp");
  }, []);
  const handleClick = (e: any) => {
    e.preventDefault();
    const section = document.querySelector("#up-skill");
    if (section) {
      section.scrollIntoView({
        behavior: "smooth"
      });
    }
    if (typeof window !== "undefined" && typeof window.gtag === "function") {
      window.gtag("config", process.env.NEXT_PUBLIC_GA_ID, {
        event_label: "Click event on Upskill the team",
        page_path: `${process.env.NEXT_PUBLIC_APP_URL}${pathName}`
      });
    }
  };
  return <div className="section__fixed-card" data-sentry-component="SectionFixedCard" data-sentry-source-file="SectionFixedCard.tsx">
      <div className="section__fixed-card-container section__container--small">
        <div className="section__fixed-card-text">
          <p>{learnerData?.name}</p>
          <Link href="https://home.growthschool.io/b2b" className="section__fixed-card-link" data-sentry-element="Link" data-sentry-source-file="SectionFixedCard.tsx">
            Looking for your team?
          </Link>
        </div>
        <div className="section__fixed-card-buttons">
          {learnerData?.brochure_url ? <Link href={learnerData?.brochure_url ?? "/"} className="section__fixed-card-button" onClick={() => {
          if (typeof window !== "undefined" && typeof window.gtag === "function") {
            window.gtag("config", process.env.NEXT_PUBLIC_GA_ID, {
              event_label: "Click event on Brochure",
              page_path: `${process.env.NEXT_PUBLIC_APP_URL}${pathName}`
            });
          }
        }}>
              <svg xmlns="http://www.w3.org/2000/svg" width="25" height="25" viewBox="0 0 25 25" fill="none">
                <path d="M8.5 12.5L12.5 16.5L16.5 12.5" stroke="black" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                <path d="M12.5 16.5V4.5" stroke="black" strokeWidth="1.5" strokeMiterlimit="10" strokeLinecap="round" />
                <path d="M19.5 17.5V18.1C19.5 19.43 18.43 20.5 17.1 20.5H7.9C6.57 20.5 5.5 19.43 5.5 18.1V17.5" stroke="black" strokeWidth="1.5" strokeMiterlimit="10" strokeLinecap="round" />
              </svg>
              Brochure
            </Link> : null}
          {learnerData?.apply_now_url ? <Link href={learnerData?.apply_now_url ?? "/"} className="section__fixed-card-button section__fixed-card-button--mint" onClick={() => {
          if (typeof window !== "undefined" && typeof window.gtag === "function") {
            window.gtag("config", process.env.NEXT_PUBLIC_GA_ID, {
              event_label: "Click event on Apply Now",
              page_path: `${process.env.NEXT_PUBLIC_APP_URL}${pathName}`
            });
          }
        }}>
              Apply Now
            </Link> : <Link href={learnerData?.buy_now_url ?? "/"} className="section__fixed-card-button section__fixed-card-button--mint" onClick={() => {
          if (typeof window !== "undefined" && typeof window.gtag === "function") {
            window.gtag("config", process.env.NEXT_PUBLIC_GA_ID, {
              event_label: "Click event on Buy Now",
              page_path: `${process.env.NEXT_PUBLIC_APP_URL}${pathName}`
            });
          }
        }}>
              {/* Buy Now */}
              {props.programType === SLPProgramType.MENTORSHIP ? "Buy Now" : props.programType === SLPProgramType.SELFPACED ? "Unlock Instant Access" : "Register Now"}
              {props.programType !== SLPProgramType.MENTORSHIP && <Image src="/images/course-diff/arrow-right.svg" alt="arrow" width={24} height={24} />}
            </Link>}
        </div>
      </div>
    </div>;
}